export default __webpack_public_path__ + "static/media/ZZC_7821(1).0d38d616.jpg";